export const CDN_URL = 
"https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";

 export const LOGO_URL = 
"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQkYjtGDVlSuIJI_03E-X4Km3ARYmWidl1ydDD-tKIOzeLK7p9NvKLGpJmLfQN-BIjnFYg&usqp=CAU" ;

export const MENUE_API = "https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=26.87560&lng=80.91150&restaurantId=";
